( function () {
    'use strict';
    e.ecom.checkout = {};
    e.ecom.checkout.init = function () {
        e.ecom.checkout.cart();
        e.ecom.checkout.delivery();
        e.ecom.checkout.payment();
        e.ecom.checkout.approve();
        e.ecom.checkout.receipt();
    };
    e.ecom.checkout.cart = function () {
        var jCheckoutCartForm = jQuery( '.js-e-checkout-form-cart' ),
            jCheckoutCartFormOrderlineUpdated = jCheckoutCartForm.find( '.js-e-orderline-updated' );
        //Set update as default action on cart form
        jCheckoutCartForm.attr( 'action', jCheckoutCartForm.find( '.js-e-form-action-update' ).attr( 'href' ) );
        jCheckoutCartForm.find( '.js-e-checkout-btn-next' ).on( 'click', function () {
            //Set next step checkout as action on cart form
            jCheckoutCartForm.attr( 'action', jCheckoutCartForm.find( '.js-e-form-action-checkout' ).attr( 'href' ) );
        } );
        //if ( history.length !== 0 ) {
        //    jCheckoutCartForm.find( '.js-e-checkout-btn-back' ).on( 'click', function ( event ) {
        //        event.preventDefault();
        //        if ( document.referrer.indexOf( 'checkout' ) !== -1 ) {
        //            location.href = this.href;
        //        }
        //        else {
        //            history.back();
        //        }
        //    } );
        //}
        if ( jCheckoutCartFormOrderlineUpdated.length === 1 ) {
            e.util.scroll.toElement( jCheckoutCartFormOrderlineUpdated, jCheckoutCartFormOrderlineUpdated.height() * -1 );
            jCheckoutCartFormOrderlineUpdated.find( 'input' ).trigger( 'select' );
        }
        jCheckoutCartForm.on( 'keydown keypress keyup', '.js-e-orderline-quantity,#EcomOrderVoucherCode', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                if ( event.type === 'keyup' ) {
                    jQuery( this ).closest( 'tr' ).find( '.js-e-orderline-btn-update-cart, .js-e-cart-update' ).trigger( 'click' );
                }
            }
        } ).find( '.js-e-orderline-quantity' ).on( 'focus', function () {
            var jThisRow = jQuery( this ).closest( 'tr' );
            e.util.scroll.toElement( jThisRow, jThisRow.height() * -1, true, true );
        } );
        jCheckoutCartForm.on( 'submit', function () {
            var jEcomOrderVoucherCode = jQuery( '#EcomOrderVoucherCode' );
            if ( jEcomOrderVoucherCode.val() === '' && jEcomOrderVoucherCode.data( 'ecomordervouchercode' ) !== '' ) {
                jEcomOrderVoucherCode.val( jEcomOrderVoucherCode.data( 'ecomordervouchercode' ) );
            }
        } );
    };
    e.ecom.checkout.delivery = function () {
        var jCheckoutDeliveryForm = jQuery( 'form[name="CheckoutDeliveryForm"]' );
        if ( jCheckoutDeliveryForm.length === 1 ) {
            //aktiver step i progress bar
            jQuery( '.e-checkout-progress .step-delivery' ).addClass( 'step-active' );
            //bind validering af form
            jCheckoutDeliveryForm.validate( {
                rules: {
                    EcomUserCreateUserName: {
                        equalTo: '#EcomOrderCustomerEmail'
                    },
                    EcomUserCreatePassword: {
                        equalTo: '#EcomUserCreateConfirmPassword'
                    }
                },
                groups: {
                    EcomOrderCustomerZipCity: 'EcomOrderCustomerZip EcomOrderCustomerCity',
                    EcomOrderDeliveryZipCity: 'EcomOrderDeliveryZip EcomOrderDeliveryCity'
                }
            } );
            //unbind hvis der klikkes på tilbage
            jCheckoutDeliveryForm.find( '.PreviousStepButton' ).on( 'click', function () {
                jCheckoutDeliveryForm.off( 'submit' );
            } );
            e.ecom.checkout.customertype();
            e.ecom.checkout.delivery.selectMethod();
            e.ecom.checkout.newslettersubscribe();
            jQuery( '.e-checkout-actions a.btn-link, .e-cart-mini a.btn' ).on( 'click', function ( event ) {
                var jThis = jQuery( this );
                event.preventDefault();
                //submit ajax
                jQuery.post( location.href, jCheckoutDeliveryForm.serialize() ).success( function () {
                    location.href = jThis.attr( 'href' );
                } );
            } );
            jCheckoutDeliveryForm.on( 'change', 'select[name*="Country"]', function ( event ) {
                var jEventTarget = jQuery( event.target ),
                    jCustomerAddressIsDeliveryAddress = jQuery( '#CustomerAddressIsDeliveryAddress' ).find( 'input[name="CustomerAddressIsDeliveryAddress"]' ).filter( ':checked' );
                if ( jEventTarget.is( '#EcomOrderCustomerCountry' ) === true && jCustomerAddressIsDeliveryAddress.val() === 'true' ) {
                    jQuery( '#EcomOrderDeliveryCountry' ).val( jQuery( '#EcomOrderCustomerCountry' ).val() );
                    e.ecom.checkout.delivery.reload();
                }
                else if ( jEventTarget.is( '#EcomOrderCustomerCountry' ) === false && jCustomerAddressIsDeliveryAddress.val() === 'false' ) {
                    e.ecom.checkout.delivery.reload();
                }
            } );
        }
    };
    e.ecom.checkout.customertype = function () {
        var jCo3EspressoCustomerType = jQuery( '#CustomerType' );
        jCo3EspressoCustomerType.find( 'input[name="Co3EspressoCustomerType"]' ).on( 'change', function () {
            if ( jCo3EspressoCustomerType.find( 'input[name="Co3EspressoCustomerType"]' ).filter( ':checked' ).val() === 'extranet' ) {
                jCo3EspressoCustomerType.find( '.js-e-login-modal-link' ).triggerHandler( 'click' );
            }
        } ).triggerHandler( 'change' );
    };
    e.ecom.checkout.newslettersubscribe = function () {
        jQuery( '#BillingAddress' ).find( 'input[name="Co3EspressoEcomOrderSubscribeToNewsletter"]' ).on( 'change', function () {
            jQuery( '#BillingAddress' ).find( 'input[name="EcomOrderSubscribeToNewsletter"]' ).val( this.checked === true ? 'true' : '' );
        } ).triggerHandler( 'change' );
    };
    //e.ecom.checkout = {};
    e.ecom.checkout.selectedShippingMethod = '';
    //e.ecom.checkout.delivery = {};
    e.ecom.checkout.delivery.reload = function () {
        jQuery( '<input>' ).attr( {
            type: 'hidden',
            id: 'CartV2.GotoStep0',
            name: 'CartV2.GotoStep0',
            value: 'CartV2.GotoStep0'
        } ).appendTo( 'form[name="CheckoutDeliveryForm"]' );
        //console.log( document.forms[ 'CheckoutDeliveryForm' ] );
        document.forms[ 'CheckoutDeliveryForm' ].submit();
    };
    e.ecom.checkout.delivery.reset = function () {
        e.ecom.checkout.delivery.alternate.reset();
        e.ecom.checkout.delivery.address.reset();
        e.ecom.checkout.delivery.gls.reset();
        e.ecom.checkout.delivery.pacsoft.reset();
        e.ecom.checkout.delivery.pickup.reset();
    };
    e.ecom.checkout.delivery.clear = function () {
        //console.log( 'e.ecom.checkout.delivery.clear' );
        e.ecom.checkout.delivery.alternate.clear();
        e.ecom.checkout.delivery.address.clear();
        //e.ecom.checkout.delivery.gls.clear();
        //e.ecom.checkout.delivery.pacsoft.clear();
        //e.ecom.checkout.delivery.pickup.clear();
    };
    e.ecom.checkout.delivery.alternate = {
        init: function () {
            jQuery( '#CustomerAddressIsDeliveryAddress' ).find( 'input[name="CustomerAddressIsDeliveryAddress"]' ).on( 'change', function () {
                //console.log( jQuery( this ), event.target );
                var jThis = jQuery( this );
                if ( jThis.is( ':checked' ) === true && jThis.val() === 'true' ) {
                    e.ecom.checkout.delivery.address.hide();
                    e.ecom.checkout.delivery.address.clear();
                }
                else {
                    e.ecom.checkout.delivery.address.show();
                }
            } );
            e.ecom.checkout.delivery.address.multiple();
        },
        show: function () {
            jQuery( '#CustomerAddressIsDeliveryAddress' ).parent().slideDown( 'fast' ).find( 'input[name="CustomerAddressIsDeliveryAddress"]' ).triggerHandler( 'change' );
        },
        hide: function () {
            jQuery( '#CustomerAddressIsDeliveryAddress' ).parent().hide();
        },
        reset: function () {
            e.util.formFieldsResetToDefault( jQuery( '#CustomerAddressIsDeliveryAddress' ).find( ':input' ) );
        },
        clear: function () {
            jQuery( '#CustomerAddressIsDeliveryAddress' ).find( ':input' ).first().prop( 'checked', true ).triggerHandler( 'change' );
        }
    };
    e.ecom.checkout.delivery.pickup = {
        init: function () {},
        show: function () {},
        hide: function () {},
        reset: function () {
            e.util.formFieldsResetToDefault( jQuery( '#DeliveryAddress' ).find( ':input' ) );
        },
        clear: function () {
            jQuery( '#DeliveryAddress' ).find( ':input' ).val( '' );
        }
    };
    e.ecom.checkout.delivery.address = {
        init: function () {
            this.multiple();
        },
        show: function () {
            jQuery( '#DeliveryAddress' ).parent().slideDown( 'fast' );
        },
        hide: function () {
            var jEcomOrderCustomerCountry = jQuery( '#EcomOrderCustomerCountry' ),
                jEcomOrderDeliveryCountry = jQuery( '#EcomOrderDeliveryCountry' );
            //console.log( jEcomOrderCustomerCountry.data( 'selected' ), jEcomOrderDeliveryCountry.data( 'selected' ), jEcomOrderDeliveryCountry.data( 'selected' ), jEcomOrderCustomerCountry.val() );
            /*
            Ingen grund til reload hvis:
            Der ikke er valgt et leveringsland, eller
            leveringslandet er det samme som kundes land, og
            der ikke er ændret på kundens land efter siden er indlæst
            */
            if ( jEcomOrderDeliveryCountry.data( 'selected' ) !== '' && ( jEcomOrderCustomerCountry.data( 'selected' ) === jEcomOrderDeliveryCountry.data( 'selected' ) && jEcomOrderCustomerCountry.data( 'selected' ) === jEcomOrderCustomerCountry.val() ) === false ) {
                //console.log( 'hide // reload' );
                //e.ecom.checkout.delivery.reload();
                e.ecom.checkout.delivery.address.clear();
            }
            else {
                //console.log( 'hide // do nothing' );
            }
            jQuery( '#DeliveryAddress' ).parent().hide();
        },
        reset: function () {
            e.util.formFieldsResetToDefault( jQuery( '#DeliveryAddress' ).find( ':input' ) );
        },
        clear: function () {
            //console.log( 'e.ecom.checkout.alternate.clear' );
            jQuery( '#DeliveryAddress' ).find( ':input' ).val( '' );
        },
        multiple: function () {
            jQuery( '#DeliveryAddressExtranet' ).find( 'input[name="CustomerAlternativeDeliveryAddress"]' ).on( 'change', function () {
                jQuery( this ).parent( 'label' ).find( 'span' ).each( function () {
                    var customerAlternativeDeliveryAddressField = jQuery( this ).data( 'field' );
                    if ( customerAlternativeDeliveryAddressField === 'EcomOrderDeliveryCountry' ) {
                        jQuery( '#DeliveryAddress' ).find( 'select#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
                        if(!jQuery('input[name="EcomOrderDeliveryName"]').val()){
                            jQuery('input[name="EcomOrderDeliveryName"]').val(jQuery('input[name="EcomOrderCustomerName"]').val());
                        }
                        jQuery( '#DeliveryAddress' ).find( 'select#' + customerAlternativeDeliveryAddressField ).trigger( 'change' );
                    }
                    else {
                        jQuery( '#DeliveryAddress' ).find( 'input#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
                    }
                    //.trigger('change');
                } );
            } ).filter( ':checked' ).triggerHandler( 'change' );
        }
    };
    e.ecom.checkout.delivery.gls = {
        parcelshops: {},
        init: function () {
            var jGLSzip = jQuery( '#EspressoGLSzip' ),
                jGLSaddress = jQuery( '#EspressoGLSaddress' ),
                jCostumerZip = jQuery( '#EcomOrderCustomerZip' ),
                jCostumerAddress = jQuery( '#EcomOrderCustomerAddress' );
            jGLSzip.add( jGLSaddress ).on( 'change blur', function () {
                jGLSzip.data( 'changed', true );
            } ).on( 'keypress', function ( event ) {
                if ( event.which === 13 ) {
                    event.preventDefault();
                    jQuery( '.js-e-gls-search' ).triggerHandler( 'click' );
                }
            } );
            // Move zip and address from DW standard field to Pacsoft field
            jCostumerZip.add( jCostumerAddress ).on( 'change', function () {
                if ( jGLSzip.data( 'changed' ) !== true ) {
                    e.ecom.checkout.delivery.gls.getZipAndAddress();
                    jQuery( '.js-e-gls-search' ).triggerHandler( 'click' );
                }
            } );
            // Prevent form submit
            jGLSzip.add( jCostumerAddress ).on( 'keypress', function ( event ) {
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    //console.log( jCostumerZip );
                    jGLSzip.valid();
                    e.ecom.checkout.delivery.gls.lookup();
                }
            } );
            jQuery( '.js-e-gls-search' ).on( 'click', function ( event ) {
                event.preventDefault();
                jGLSzip.valid();
                e.ecom.checkout.delivery.gls.lookup();
            } );
            jQuery( '#js-e-gls-result-container' ).on( 'change', 'input[name="gls-parcelshop"]', function () {
                e.ecom.checkout.delivery.gls.selectShop( jQuery( 'input[name="gls-parcelshop"]' ).index( this ) );
            } );
        },
        show: function () {
            //console.log( e.ecom.checkout.delivery );
            e.ecom.checkout.delivery.gls.getZipAndAddress();
            jQuery( '#DeliveryGLS' ).parent().slideDown( 'fast' );
            if ( jQuery( '#EspressoGLSzip' ).val() !== '' ) {
                e.ecom.checkout.delivery.gls.lookup();
            }
        },
        hide: function () {
            jQuery( '#DeliveryGLS' ).parent().slideUp( 'fast' );
        },
        reset: function () {
            jQuery( '#EspressoGLSzip' ).val( '' ).data( 'changed', false );
            jQuery( '#EspressoGLSaddress' ).val( '' ).data( 'changed', false );
            jQuery( '#EspressoGLSparcelShopID' ).val( '' );
        },
        getZipAndAddress: function () {
            var jGLSzip = jQuery( '#EspressoGLSzip' ),
                jGLSaddress = jQuery( '#EspressoGLSaddress' ),
                jCostumerZip = jQuery( '#EcomOrderCustomerZip' ),
                jCostumerAddress = jQuery( '#EcomOrderCustomerAddress' );
            if ( jGLSzip.data( 'changed' ) !== true ) {
                jGLSzip.val( jQuery.trim( jCostumerZip.val() ) );
                jGLSaddress.val( jQuery.trim( jCostumerAddress.val() ) );
            }
        },
        lookup: function () {
            var glsURL = '/glslookup.ashx',
                jGLSzip = jQuery( '#EspressoGLSzip' ),
                jGLSaddress = jQuery( '#EspressoGLSaddress' ),
                jGLSparcelShopID = jQuery( '#EspressoGLSparcelShopID' ),
                strAddress = jQuery.trim( jGLSaddress.val() );
            if ( jGLSzip.valid() === true && jGLSaddress.valid() === true ) {
                e.ecom.checkout.delivery.gls.hideError();
                e.ecom.checkout.delivery.gls.showLoader();
                glsURL += '?count=6';
                glsURL += '&zipcode=' + encodeURIComponent( jQuery.trim( jGLSzip.val() ) );
                if ( strAddress !== '' ) {
                    if ( strAddress.indexOf( /\d/ ) === -1 ) {
                        strAddress += ' 1';
                    }
                    glsURL += '&street=' + encodeURIComponent( strAddress );
                    glsURL += '&type=ADDRESS';
                }
                else {
                    glsURL += '&type=ZIP';
                }
                jQuery.ajax( {
                    url: glsURL,
                    cache: false
                } ).done( function ( data ) {
                    if ( data.parcelshops.length > 0 ) {
                        e.ecom.checkout.delivery.gls.parcelshops = data.parcelshops;
                        e.ecom.checkout.delivery.gls.hideLoader();
                        e.ecom.checkout.delivery.gls.renderResults();
                        if ( jGLSparcelShopID.val() !== '' ) {
                            //Hvis vi kommer herind er der allerede valgt en pakkeshop og den skal derfor markers/vælges
                            jQuery( '#gls-parcelshop-' + jGLSparcelShopID.val() ).prop( 'checked', true ).trigger( 'change' );
                        }
                    }
                    else {
                        //Ingen resultater eller ugyldig søgning
                        e.ecom.checkout.delivery.gls.hideLoader();
                        e.ecom.checkout.delivery.gls.showError();
                    }
                } ).fail( function () {
                    //AJAX eller netværks fejl
                    e.ecom.checkout.delivery.gls.hideLoader();
                    e.ecom.checkout.delivery.gls.showError();
                } );
            }
        },
        renderResults: function () {
            // TODO: Make Handlebars template for rendering results
            var jDeliveryGLSshops = jQuery( '<div class="controls gls-shops"></div>' );
            jQuery.each( e.ecom.checkout.delivery.gls.parcelshops, function ( key, val ) {
                if ( key % 2 === 0 ) {
                    jDeliveryGLSshops.append( '<div class="row-fluid">' + '<div class="span6">' + '<label class="radio" for="gls-' + e.ecom.checkout.delivery.gls.parcelshops[ key ].Number + '">' + '<input type="radio" class="required" name="gls-shop" id="gls-' + e.ecom.checkout.delivery.gls.parcelshops[ key ].Number + '" value="' + key + '">' + '<strong>' + val.CompanyName + '</strong><br><small>' + val.Streetname2 + '</small><br>' + val.Streetname + '<br>' + val.ZipCode + ' ' + val.CityName + '<br>' + '</label>' + '</div>' + ( key + 1 < e.ecom.checkout.delivery.gls.parcelshops.length ? '<div class="span6">' + '<label class="radio" for="gls-' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Number + '">' + '<input type="radio" class="required" name="gls-shop" id="gls-' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Number + '" value="' + ( key + 1 ) + '">' + '<strong>' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].CompanyName + '</strong><br><small>' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Streetname2 + '</small><br>' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Streetname + '<br>' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].ZipCode + ' ' + e.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].CityName + '</label>' + '</div>' : '' ) + '</div>' );
                }
            } );
            var jDeliveryGLS = jQuery( '#DeliveryGLS' );
            jDeliveryGLS.find( '.gls-shops' ).replaceWith( jDeliveryGLSshops );
        },
        showError: function () {
            jQuery( '.js-e-gls-noresult' ).removeClass( 'hide' );
        },
        hideError: function () {
            jQuery( '.js-e-gls-noresult' ).addClass( 'hide' );
        },
        showLoader: function () {
            jQuery( '.js-e-gls-loader' ).removeClass( 'hide' );
        },
        hideLoader: function () {
            jQuery( '.js-e-gls-loader' ).addClass( 'hide' );
        },
        selectShop: function ( selectedIndex ) {
            jQuery( '#EspressoGLSparcelShopID' ).val( e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].servicePointId );
            jQuery( '#EcomOrderDeliveryName' ).val( e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].name );
            jQuery( '#EcomOrderDeliveryCompany' ).val( 'GLS Pakkeshop ' + e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].servicePointId );
            jQuery( '#EcomOrderDeliveryAddress' ).val( e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].deliveryAddress.streetName + ' ' + e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].deliveryAddress.streetNumber );
            jQuery( '#EcomOrderDeliveryZip' ).val( e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].deliveryAddress.postalCode );
            jQuery( '#EcomOrderDeliveryCity' ).val( e.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].deliveryAddress.city );
        }
    };
    e.ecom.checkout.delivery.pacsoft = {
        servicepoints: {},
        init: function () {
            var jPacsoftZip = jQuery( '#EspressoPacsoftZip' ),
                jPacsoftAddress = jQuery( '#EspressoPacsoftAddress' ),
                jCostumerZip = jQuery( '#EcomOrderCustomerZip' ),
                jCostumerAddress = jQuery( '#EcomOrderCustomerAddress' );
            jPacsoftZip.add( jPacsoftAddress ).on( 'change blur', function () {
                jPacsoftZip.data( 'changed', true );
            } ).on( 'keypress', function ( event ) {
                if ( event.which === 13 ) {
                    event.preventDefault();
                    jQuery( '.js-e-pacsoft-search' ).triggerHandler( 'click' );
                }
            } );
            // Move zip and address from DW standard field to Pacsoft field
            jCostumerZip.add( jCostumerAddress ).on( 'change', function () {
                if ( jPacsoftZip.data( 'changed' ) !== true ) {
                    e.ecom.checkout.delivery.pacsoft.getZipAndAddress();
                    jQuery( '.js-e-pacsoft-search' ).triggerHandler( 'click' );
                }
            } );
            // Prevent form submit
            jPacsoftZip.add( jCostumerAddress ).on( 'keypress', function ( event ) {
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    //console.log( jCostumerZip );
                    jPacsoftZip.valid();
                    e.ecom.checkout.delivery.pacsoft.lookup();
                }
            } );
            jQuery( '.js-e-pacsoft-search' ).on( 'click', function ( event ) {
                event.preventDefault();
                jPacsoftZip.valid();
                e.ecom.checkout.delivery.pacsoft.lookup();
            } );
            jQuery( '#js-e-pacsoft-result-container' ).on( 'change', 'input[name="pacsoft-servicepoint"]', function () {
                e.ecom.checkout.delivery.pacsoft.selectShop( jQuery( 'input[name="pacsoft-servicepoint"]' ).index( this ) );
            } );
        },
        show: function () {
            e.ecom.checkout.delivery.pacsoft.getZipAndAddress();
            jQuery( '#DeliveryPacsoft' ).parent().slideDown( 'fast' );
            if ( jQuery( '#EspressoPacsoftZip' ).val() !== '' ) {
                e.ecom.checkout.delivery.pacsoft.lookup();
            }
        },
        hide: function () {
            jQuery( '#DeliveryPacsoft' ).parent().slideUp( 'fast' );
        },
        reset: function () {
            jQuery( '#EspressoPacsoftZip' ).val( '' ).data( 'changed', false );
            jQuery( '#EspressoPacsoftAddress' ).val( '' ).data( 'changed', false );
            jQuery( '#EspressoPacsoftServicePointID' ).val( '' );
        },
        getZipAndAddress: function () {
            var jPacsoftZip = jQuery( '#EspressoPacsoftZip' ),
                jPacsoftAddress = jQuery( '#EspressoPacsoftAddress' ),
                jCostumerZip = jQuery( '#EcomOrderCustomerZip' ),
                jCostumerAddress = jQuery( '#EcomOrderCustomerAddress' );
            if ( jPacsoftZip.data( 'changed' ) !== true ) {
                jPacsoftZip.val( jQuery.trim( jCostumerZip.val() ) );
                jPacsoftAddress.val( jQuery.trim( jCostumerAddress.val() ) );
            }
        },
        lookup: function () {
            var pacsoftURL = '/pnlookup.ashx',
                jPacsoftZip = jQuery( '#EspressoPacsoftZip' ),
                jPacsoftAddress = jQuery( '#EspressoPacsoftAddress' ),
                jPacsoftServicePointID = jQuery( '#EspressoPacsoftServicePointID' );
            if ( jPacsoftZip.valid() === true && jPacsoftAddress.valid() === true ) {
                e.ecom.checkout.delivery.pacsoft.hideError();
                e.ecom.checkout.delivery.pacsoft.showLoader();
                pacsoftURL += '?countryCode=' + jQuery( '#EcomOrderCustomerCountry' ).val();
                pacsoftURL += '&streetName=' + encodeURIComponent( jQuery.trim( jPacsoftAddress.val() ) );
                pacsoftURL += '&postalCode=' + encodeURIComponent( jQuery.trim( jPacsoftZip.val() ) );
                pacsoftURL += '&numberOfServicePoints=6';
                jQuery.ajax( {
                    url: pacsoftURL,
                    cache: false
                } ).done( function ( data ) {
                    if ( data.error === undefined ) {
                        e.ecom.checkout.delivery.pacsoft.servicepoints = data.servicePointInformationResponse.servicePoints;
                        e.ecom.checkout.delivery.pacsoft.hideLoader();
                        e.ecom.checkout.delivery.pacsoft.renderResults();
                        if ( jPacsoftServicePointID.val() !== '' ) {
                            //Hvis vi kommer herind er der allerede valgt en pakkeshop og den skal derfor markers/vælges
                            jQuery( '#pacsoft-servicepoint-' + jPacsoftServicePointID.val() ).prop( 'checked', true ).trigger( 'change' );
                        }
                    }
                    else {
                        //Ingen resultater eller ugyldig søgning
                        e.ecom.checkout.delivery.pacsoft.hideLoader();
                        e.ecom.checkout.delivery.pacsoft.showError();
                    }
                } ).fail( function () {
                    //AJAX eller netværks fejl
                    e.ecom.checkout.delivery.pacsoft.hideLoader();
                    e.ecom.checkout.delivery.pacsoft.showError();
                } );
            }
        },
        renderResults: function () {
            // TODO: Make Handlebars template for rendering results
            jQuery( '#js-e-pacsoft-result-container .js-e-pacsoft-servicepoints' ).empty();
            var jDeliveryPacsoftServicePoints = jQuery( '<div class="controls js-e-pacsoft-servicepoints"></div>' );
            var currentShopID = jQuery( '#EspressoPacsoftServicePointID' ).val();
            jQuery.each( e.ecom.checkout.delivery.pacsoft.servicepoints, function ( key, val ) {
                if ( key % 2 === 0 ) {
                    var htmlElm = [ '<div class="row-fluid">', '<div class="span6">', '<label class="radio">', '<input type="radio" class="required" name="pacsoft-servicepoint" ' + ( currentShopID === e.ecom.checkout.delivery.pacsoft.servicepoints[ key ].servicePointId ? 'checked="checked"' : '' ) + ' id="pacsoft-servicepoint-' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key ].servicePointId + '" value="' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key ].servicePointId + '">', '<strong>' + val.name + '</strong><br>' + val.visitingAddress.streetName + ' ' + val.visitingAddress.streetNumber + '<br>',
                        val.visitingAddress.postalCode + ' ' + val.visitingAddress.city + '<br>' + '</label>', '</div>'
                    ];
                    if ( key + 1 < e.ecom.checkout.delivery.pacsoft.servicepoints.length ) {
                        var htmlElm2 = [ '<div class="span6">', '<p><label class="radio" >', '<input type="radio" class="required" name="pacsoft-servicepoint" ' + ( currentShopID === e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].servicePointId ? 'checked="checked"' : '' ) + ' id="pacsoft-servicepoint-' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].servicePointId + '" value="' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].servicePointId + '">', '<strong>' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].name + '</strong><br>', '' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].visitingAddress.streetName + ' ' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].visitingAddress.streetNumber + '<br>',
                            e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].visitingAddress.postalCode + ' ' + e.ecom.checkout.delivery.pacsoft.servicepoints[ key + 1 ].deliveryAddress.city, '</label></p>', '</div>'
                        ].join( '' );
                        htmlElm.push( htmlElm2 );
                    }
                    htmlElm.push( '</div>' );
                    jDeliveryPacsoftServicePoints.append( htmlElm.join( '' ) );
                }
            } );
            jQuery( '.js-e-pacsoft-servicepoints' ).replaceWith( jDeliveryPacsoftServicePoints );
        },
        showError: function () {
            jQuery( '.js-e-pacsoft-noresult' ).removeClass( 'hide' );
        },
        hideError: function () {
            jQuery( '.js-e-pacsoft-noresult' ).addClass( 'hide' );
        },
        showLoader: function () {
            jQuery( '.js-e-pacsoft-loader' ).removeClass( 'hide' );
        },
        hideLoader: function () {
            jQuery( '.js-e-pacsoft-loader' ).addClass( 'hide' );
        },
        selectShop: function ( selectedIndex ) {
            jQuery( '#EspressoPacsoftServicePointID' ).val( e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].servicePointId );
            jQuery( '#EcomOrderDeliveryName' ).val( e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].name );
            jQuery( '#EcomOrderDeliveryCompany' ).val( 'Post Danmark ' + e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].servicePointId );
            jQuery( '#EcomOrderDeliveryAddress' ).val( e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].deliveryAddress.streetName + ' ' + e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].deliveryAddress.streetNumber );
            jQuery( '#EcomOrderDeliveryZip' ).val( e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].deliveryAddress.postalCode );
            jQuery( '#EcomOrderDeliveryCity' ).val( e.ecom.checkout.delivery.pacsoft.servicepoints[ selectedIndex ].deliveryAddress.city );
        }
    };
    // Build ShippingID select logic
    e.ecom.checkout.shipping = {
        SHIP1: { // Post Danmark
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP2: { // GLS pakkeshop
            onInit: [ e.ecom.checkout.delivery.gls.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.gls.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.gls.hide ]
        },
        SHIP3: { // Ukendt
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.address.hide ]
        },
        SHIP4: { // I henhold til aftale
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.hide ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP5: { // Pacsoft ServicePoint
            onInit: [ e.ecom.checkout.delivery.pacsoft.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.pacsoft.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.pacsoft.hide ]
        },
        SHIP6: { // Post Danmark Erhverv
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP7: { // Fragtmand
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP8: { // Fragtmand Grønland og Færøerne
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP11: { // Fragtmand Grønland og Færøerne
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP12: { // Fragtmand Grønland og Færøerne
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP14: { // Fragtmand Grønland og Færøerne
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP22: { // Standard MX Shipping
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        SHIP19: { // Standard RO Shipping
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        },
        DEFAULT: { // Default som man kan tage udgangpunkt i ved nye leveringsmetoder
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        }
    };
    e.ecom.checkout.delivery.selectMethod = function () {
        //console.log( 'selectMethod' );
        var jShippingMethods = jQuery( '#ShippingMethods' ).find( 'input[name="EcomCartShippingmethodID"]' ),
            arrOnInitCallbacks = [];
        // Run init methods for all methods on page
        jShippingMethods.each( function () {
            var shippingObject = e.ecom.checkout.shipping[ this.value ];
            if ( shippingObject ) {
                for ( var s = 0; s < shippingObject.onInit.length; s++ ) {
                    //console.log( shippingObject.onInit[ s ], arrOnInitCallbacks.indexOf( shippingObject.onInit[ s ] ) === -1 );
                    if ( arrOnInitCallbacks.indexOf( shippingObject.onInit[ s ] ) === -1 ) {
                        arrOnInitCallbacks.push( shippingObject.onInit[ s ] );
                    }
                }
            }
        } );
        for ( var i = 0; i < arrOnInitCallbacks.length; i++ ) {
            arrOnInitCallbacks[ i ]();
        }
        // Event that runs when new shipping is selected
        jShippingMethods.on( 'change', function () {
            //console.log( 'change', e.ecom.checkout.shipping[ jQuery( this ).val() ] );
            // Run deselect callbacks on previously selected shipping method
            if ( e.ecom.checkout.selectedShippingMethod !== '' ) {
                var previousShippingObject = e.ecom.checkout.shipping[ e.ecom.checkout.selectedShippingMethod ];
                if ( previousShippingObject !== undefined ) {
                    var arrDeselectCallbacks = previousShippingObject.onDeselectCallbacks;
                    if ( arrDeselectCallbacks ) {
                        for ( var i = 0; i < arrDeselectCallbacks.length; i++ ) {
                            arrDeselectCallbacks[ i ]();
                            //console.log( 'arrDeselectCallbacks', arrDeselectCallbacks[ i ] );
                        }
                    }
                }
                else {
                    var arrDeselectCallbacks = e.ecom.checkout.shipping[ 'DEFAULT' ].onDeselectCallbacks;
                    if ( arrDeselectCallbacks ) {
                        for ( var i = 0; i < arrDeselectCallbacks.length; i++ ) {
                            arrDeselectCallbacks[ i ]();
                            //console.log( 'arrDeselectCallbacks', arrDeselectCallbacks[ p ] );
                        }
                    }
                }
            }
            // Update variable with the selected shipping method
            e.ecom.checkout.selectedShippingMethod = jQuery( this ).val();
            // Rund select callbacks on currently selected shipping method
            var currentShippingObject = e.ecom.checkout.shipping[ e.ecom.checkout.selectedShippingMethod ];
            if ( currentShippingObject !== undefined ) {
                var arrSelectCallbacks = currentShippingObject.onSelectCallbacks;
                if ( arrSelectCallbacks ) {
                    for ( var p = 0; p < arrSelectCallbacks.length; p++ ) {
                        arrSelectCallbacks[ p ]();
                        //console.log( 'arrSelectCallbacks', arrSelectCallbacks[ p ] );
                    }
                }
            }
            else {
                var arrSelectCallbacks = e.ecom.checkout.shipping[ 'DEFAULT' ].onSelectCallbacks;
                if ( arrSelectCallbacks ) {
                    for ( var p = 0; p < arrSelectCallbacks.length; p++ ) {
                        arrSelectCallbacks[ p ]();
                        //console.log( 'arrSelectCallbacks', arrSelectCallbacks[ p ] );
                    }
                }
            }
        } );
        // Select first if server didn't select one-
        if ( jShippingMethods.filter( ':checked' ).length === 0 ) {
            jShippingMethods.first().prop( 'checked', true );
        }
        // Trigger change event on selected shipping method
        jShippingMethods.filter( ':checked' ).triggerHandler( 'change' );
    };
    e.ecom.checkout.payment = function () {
        var jCheckoutPaymentForm = jQuery( 'form[name="CheckoutPaymentForm"]' );
        if ( jCheckoutPaymentForm.length === 1 ) {
            jQuery( '.e-checkout-progress .step-payment' ).addClass( 'step-active' );
        }
        var jPaymentMethods = jQuery( '#PaymentMethods' ).find( 'input[name="EcomCartPaymethodID"]' );
        if ( jPaymentMethods.filter( ':checked' ).length === 0 ) {
            jPaymentMethods.first().prop( 'checked', true );
        }
        //jPaymentMethods.filter(':checked').triggerHandler('change');
    };
    e.ecom.checkout.approve = function () {
        var jCheckoutApproveForm = jQuery( 'form[name="CheckoutApproveForm"]' );
        if ( jCheckoutApproveForm.length === 1 ) {
            jQuery( '.e-checkout-progress .step-approve' ).addClass( 'step-active' );
            jCheckoutApproveForm.validate( {} );
            jCheckoutApproveForm.find( '.PreviousStepButton' ).on( 'click', function () { //unbind hvis der klikkes på tilbage
                jCheckoutApproveForm.off( 'submit' );
            } );
            //Hente handelsbetingelser til modal
            var jTermsAndConditionsModal = jQuery( '#TermsAndConditions .modal' ).on( 'shown', function () {
                jQuery( this ).find( 'button[data-dismiss="modal"]' ).first().focus();
            } ).on( 'hide', function () {
                jQuery( this ).find( 'button[data-dismiss="modal"]' ).first().blur();
            } );
            jTermsAndConditionsModal.find( '.modal-body .row-fluid' ).load( jTermsAndConditionsModal.find( 'a' ).attr( 'href' ) + ' .featured .row [class*=span]' );
            jTermsAndConditionsModal.find( '.modal-footer .btn-primary' ).on( 'click', function () {
                jQuery( '#EcomOrderCustomerAccepted' ).prop( 'checked', true ).valid();
            } );
        }
    };
    e.ecom.checkout.receipt = function () {
        var jCheckoutReceiptForm = jQuery( 'form[name="CheckoutReceiptForm"]' );
        if ( jCheckoutReceiptForm.length === 1 ) {
            jQuery( '.e-checkout-progress .step-receipt' ).addClass( 'step-active' );
        }
    };
}() );
